import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { SecurityApiClient } from "../api-client/api-client";
import {
  ChangePasswordErrorCode,
  type ChangePasswordParams,
  type ChangePasswordResponse
} from "../types";

export default function useChangePasswordMutation(
  options?: UseMutationOptions<ChangePasswordResponse, Error, ChangePasswordParams>
) {
  const { t } = useTranslation(["pass"]);

  return useMutation<ChangePasswordResponse, Error, ChangePasswordParams>({
    mutationFn: async (params: ChangePasswordParams) => {
      const data = await SecurityApiClient.updatePassword(params.old_password, params.password);
      if (!data.success) {
        throw new Error(
          data.errorCode === ChangePasswordErrorCode.WrongOTP
            ? t("olkypass.securityPage.passwordSection.2fa.modal.notifications.otp.error")
            : data.errorCode === ChangePasswordErrorCode.AlreadyUsed
              ? t("flow.id_control.error.password_already_used")
              : t("flow.id_control.error.password_not_correct")
        );
      }
      return data;
    },
    ...options
  });
}
